/** The checks a question passes before it is sent: the words, and two to four different answers. */
export const QUESTION_MAX = 120;
export const ANSWER_MAX = 40;

export function readyQuestion(text: string, options: string[]): { text: string; options: string[] } | { error: string } {
  const q = text.trim();
  if (!q) return { error: "Write the question first" };
  const seen = new Set<string>();
  const opts: string[] = [];
  for (const o of options.map((x) => x.trim()).filter(Boolean)) {
    if (!seen.has(o.toLowerCase())) {
      seen.add(o.toLowerCase());
      opts.push(o);
    }
  }
  if (opts.length < 2) return { error: "Add at least two answers" };
  return { text: q, options: opts.slice(0, 4) };
}
